import React, { ComponentProps } from "react";

import { Controller, Message, useFormContext } from "react-hook-form";

import Combobox, { ComboboxOption, ComboboxProps } from "../Combobox/Combobox";

interface FormComboboxFieldProps<T extends ComboboxOption<string>>
  extends Pick<ComboboxProps, "resourceName"> {
  name: string;
  label: string;
  required?: Message | false;
  rules?: ComponentProps<typeof Controller>["rules"];
  values: T[];
  defaultValue?: T;
  preserveSearchOnSelect?: boolean;
  clearOthersOnUndefined?: boolean;
}

export default function FormComboboxField<T extends ComboboxOption<string>>({
  name,
  label,
  required,
  rules,
  values,
  defaultValue,
  resourceName,
  preserveSearchOnSelect = false,
  clearOthersOnUndefined = false,
}: FormComboboxFieldProps<T>): JSX.Element {
  const { control, formState } = useFormContext();

  return (
    <Controller
      defaultValue={defaultValue}
      name={name}
      control={control}
      rules={{ required, ...rules }}
      render={({ field, fieldState }) => {
        return (
          <Combobox
            label={label}
            resourceName={resourceName}
            value={field.value}
            onChange={field.onChange}
            options={values}
            preserveSearchOnSelect={preserveSearchOnSelect}
            clearOthersOnUndefined={clearOthersOnUndefined}
            error={
              fieldState.invalid &&
              (fieldState.isTouched || formState.isSubmitted)
            }
            helperText={
              fieldState.invalid &&
              (fieldState.isTouched || formState.isSubmitted)
                ? (fieldState.error?.message as string)
                : undefined
            }
          />
        );
      }}
    />
  );
}
